import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('img', 'mfaSetupPush', ['duoBarcode']);